export const CPF_LENGTH = 11

export const CNPJ_LENGTH = 14
